import React from 'react';
import { Image } from '../image/image.react-component';
/** React prop interface for `Picture` component. */

/**
 * ### Picture
 *
 * @remarks
 * A React wrapper for the HTML `<picture>` element.  Uses the {@link Image| Image} component for the `<img>` element.
 */
export const Picture = props => {
  const {
    sources,
    className,
    imgClassName,
    ...imgProps
  } = props;
  return /*#__PURE__*/React.createElement("picture", {
    className: className
  }, props.sources.map((_ref, index) => {
    let { ...sourceProps
    } = _ref;
    return /*#__PURE__*/React.createElement("source", Object.assign({
      key: index
    }, sourceProps));
  }), /*#__PURE__*/React.createElement(Image, Object.assign({
    className: imgClassName
  }, imgProps)));
};
//# sourceMappingURL=picture.react-component.js.map